<template>
    <div class="service-downloads">
        <h6 class="font-weight-bold my-3">Resource Downloads</h6>
            <div class="d-flex flex-row justify-content-center mb-3 report-summary">
                <div class="counter p-2 flex-fill text-center">
                    <h2>{{ downloads.all }}</h2>
                    <p>Total Downloads</p>
                </div>
                <div class="counter p-2 flex-fill text-center">
                    <h2>{{ downloads.month }}</h2>
                    <p>This Month</p>
                </div>
                <div v-if="services.length > 1" class="counter p-2 flex-fill text-center" v-for="service in services">
                    <h2>{{ service.downloads.countMonth }} <span class="text-muted">|</span> {{ service.downloads.countAll }}</h2>
                    <p>{{ service.name }}<br><small class="text-muted" style="font-size: 0.65em;">Month | Total</small></p>
                </div>
        </div>
        <table class="table table-sm table-striped">
            <thead class="thead-dark">
            <tr>
                <th>Resource Downloaded</th>
                <th v-if="services.length > 1">Belongs To</th>
                <th>Region</th>
                <th width="100px">To Date</th>
                <th width="100px">This Month</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="download in downloads.detailed.downloads_by_file">
                <td style="overflow: hidden; white-space: nowrap;">{{ download.resource.title }}</td>
                <td v-if="services.length > 1">{{ download.sitename }}</td>
                <td>{{ download.region }}</td>
                <td>{{ download.count_all }}</td>
                <td>{{ download.count_month }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: "ReportDownloads",
        props: ['downloads','services']
    }
</script>

<style scoped>

</style>
